import Icon from '@ant-design/icons';
import classNames from 'classnames';
import { useContext } from 'react';

import RightSvg from '@/components/Icon/svgs/right.svg';
import type { EventCreateSessionInterface } from '@/components/chat-app/utils/utils';
import { CONTAINER_EVENT } from '@/components/chat-app/utils/utils';
import HomeContext from '@/context/HomeContext';
import { LAYOUT_SIZE } from '@/hooks/useLayoutSize';
import useStorage from '@/hooks/useStorage';
import useFlashbackStore from '@/store/useFlashbackStore';
import { EVENT } from '@/utils/event';

import styles from './index.less';

interface IProps {
  type?: 'home' | 'chat';
  className?: string;
  onClick?: () => void;
}

const Flashback = (props: IProps) => {
  const { className, onClick, type = 'home' } = props;
  const [layoutSize] = useStorage('layoutSize');
  const flashback = useFlashbackStore((state) => state.flashback);
  const setFlashback = useFlashbackStore((state) => state.setFlashback);
  const inChat = type === 'chat';

  const { setContext } = useContext(HomeContext);

  const handleClick = () => {
    if (!flashback || flashback.unread === false) return;

    setContext({
      chatHomepageRoute: undefined,
      chatCircleRoute: undefined,
      chatCallContext: undefined
    });

    dispatchEvent(
      new CustomEvent<EventCreateSessionInterface>(CONTAINER_EVENT.CREATE_SESSION, {
        detail: {
          params: {
            newSession: flashback.chatSessionId ? undefined : true,
            originSessionId: flashback.chatSessionId,
            extParams: {
              greetingText: flashback.content,
              flashbackId: flashback.id
            }
          },
          callback: (chatSessionId) => {
            setFlashback({ ...flashback, chatSessionId: chatSessionId, unread: false });
          }
        }
      })
    );

    if (layoutSize !== LAYOUT_SIZE.LARGE) {
      dispatchEvent(new CustomEvent(EVENT.SHOW_MODAL_CHAT));
    } else {
      dispatchEvent(new CustomEvent(EVENT.CHANGE_CHAT_STATUS_LAYOUT_TRULY, { detail: 'normal' }));
    }

    onClick?.();
  };

  if (!flashback || flashback.unread === false) return null;

  return (
    <div
      className={classNames(
        styles.flashback,
        className,
        {
          [styles.hidden]: !flashback.unread,
          [styles.inChat]: inChat
        },
        'group'
      )}
      onClick={handleClick}
    >
      {inChat ? (
        <img
          className="mr-[6px] rounded-[50%] w-6 h-6 shadow-[0px_0px_8px_0px_rgba(119,43,123,0.12)]"
          src="https://mindverseglobal.mindverse.com/front-img/crm/1737439207363/mebot-bio.png"
        />
      ) : null}
      <span className="text-sm leading-6 text-[#231309] transition-colors group-hover:text-[#756C5D]">
        {flashback.content}
      </span>
      {inChat ? <Icon alt="" className="text-[12px] text-[#756C5D]" component={RightSvg} /> : null}
    </div>
  );
};

export default Flashback;
